var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-image-message"},[_c('PreviewAvatar'),_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"Preview Image"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }